import { FlowChartCondition } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartConditionNode'

export class FlowChartConditionBuilder {
  private field: string | null = null
  private condition: string | null = null
  private value: string | null = null

  withField(field: string | null): FlowChartConditionBuilder {
    this.field = field
    return this
  }

  withCondition(condition: string | null): FlowChartConditionBuilder {
    this.condition = condition
    return this
  }

  withValue(value: string | null): FlowChartConditionBuilder {
    this.value = value
    return this
  }

  build(): FlowChartCondition {
    return {
      field: this.field,
      condition: this.condition,
      value: this.value,
    }
  }
}
